//remove console for production app
import { ENABLE_DEVELOPER_TOOLS } from 'nike-ui/src/devtools/utils';

if (!ENABLE_DEVELOPER_TOOLS && window && window.console) {
    window.console.log = function() {};
    window.console.error = function() {};
    window.console.warn = function() {};
    window.console.info = function() {};
    window.console.debug = function() {};
    window.console.groupCollapsed = function() {};
    window.console.groupEnd = function() {};
}
